class AuthUI {
    constructor() {
        this.initialized = false;

    }

    init() {
        if (this.initialized) return;
        this.initialized = true;


        this.attachEventListeners();
    }

    createAuthCard() {
        // now need to create the auth card
    }   
    

    updateUI(session, displayName = 'Guest') {
        if (__LOG_INFO__) AppLog.info('updateUI', session)
        const mainAuthBtn = window.AuthUI.getElements().mainAuthBtn;
        const mainAccountBtn = window.AuthUI.getElements().mainAccountBtn;
        const accountPopUp = document.querySelector('#account-pop-up')

        if (session) {
            const user = session?.user;
            const email = user?.email;
            const name = user?.user_metadata?.display_name;
            const nameToDisplay = name ||  email || 'Guest';
            const aid = user?.id ? String(user.id).slice(-6).toUpperCase() : '';

            const displayedNameText =  window.AuthUI.getElements().displayedNameText
            const displayedNameInput =  window.AuthUI.getElements().displayedNameInput

            if (displayedNameText) {
                displayedNameText.style.whiteSpace = 'normal';
                displayedNameText.style.display = 'block';
                const did = session.device_id ? String(session.device_id).slice(-6).toUpperCase() : null;
                let headerHtml = nameToDisplay;
                if (aid) {
                    headerHtml += `<br><small style="font-size: 0.8em; opacity: 0.8;">AID: ${aid}`;
                    if (did) headerHtml += ` / DID: ${did}`;
                    headerHtml += `</small>`;
                }
                displayedNameText.innerHTML = headerHtml;
                displayedNameText.dataset.rawName = nameToDisplay;
                displayedNameText.dataset.aid = aid;
            }
            if (displayedNameInput) displayedNameInput.value = nameToDisplay

            if (mainAuthBtn && mainAccountBtn) {
                mainAuthBtn.classList.add('hidden');
                mainAccountBtn.classList.remove('hidden');
            }

            if (accountPopUp) {
                const isAnonymousUser = session.user.is_anonymous
                if (isAnonymousUser) {
                    accountPopUp.classList.add('is-anonymous');
                    // Anonymous user should not have watchlist access
                    document.dispatchEvent(new CustomEvent('watchlist:auth-changed', { detail: { reason: 'anonymous' } }));
                } else {
                    accountPopUp.classList.remove('is-anonymous');
                    // Real session ready — trigger watchlist state refresh
                    document.dispatchEvent(new CustomEvent('watchlist:auth-changed', { detail: { reason: 'signed_in' } }));
                }
            }

            if (window.gtag) gtag('event', `Desktop_TopNav_Account_LogIn`);
        } else {
            window.AuthUI.closeAccountModal()
            if (mainAuthBtn && mainAccountBtn) {
                mainAuthBtn.classList.remove('hidden');
                mainAccountBtn.classList.add('hidden');
            }
            // Session lost (logged out / account deleted)
            document.dispatchEvent(new CustomEvent('watchlist:auth-changed', { detail: { reason: 'signed_out' } }));

            if (window.gtag) gtag('event', `Desktop_TopNav_Account_LogOut`);
        }
    }
    
    
    updateButtonState(consentGiven, supabaseReady) {
        // button control
        if (__LOG_INFO__) AppLog.info('updateButtonState', consentGiven)

        const cookieConsentContainer = document.querySelector('.cookie-consent-container');
        if (consentGiven) {
            cookieConsentContainer.classList.add('minimized');
            // If session is already loaded and valid (e.g. cookies re-accepted after decline),
            // notify watchlist to re-initialize — covers case where userInitialized=true
            // and initializeUserOnce() would return early without calling updateUI()
            const session = window.currentSession;
            if (session && session.user && !session.user.is_anonymous) {
                document.dispatchEvent(new CustomEvent('watchlist:auth-changed', { detail: { reason: 'signed_in' } }));
            }
        } else {
            cookieConsentContainer.classList.remove('minimized');
            // Cookies declined — watchlist access not allowed
            document.dispatchEvent(new CustomEvent('watchlist:auth-changed', { detail: { reason: 'consent_revoked' } }));
        }
        window.AuthUI.getElements().mainAuthBtn.dataset.restricted = String(!consentGiven)
        window.AuthUI.getElements().mainAccountBtn.dataset.restricted = String(!consentGiven)
    }

    attachEventListeners() {
        // click auth button
        const authBtn = window.AuthUI.getElements().mainAuthBtn;
        if (authBtn) {
            authBtn.addEventListener('click', () => {
                if (authBtn.dataset.restricted === 'true') {
                    // window.WatchlistApp.Popup.showNotificationPopup('Login Restricted', 'You can not log in until accept the cookies');
                    const consentElement = document.querySelector('.cookie-consent-container');
                    if (consentElement) consentElement.classList.remove('minimized');
                } else {
                    window.AuthUI.showAuthModal();
                }
            });
        }
        // click account button
        const accountBtn = window.AuthUI.getElements().mainAccountBtn;
        if (accountBtn) {
            accountBtn.addEventListener('click', () => {
                if (accountBtn.dataset.restricted === 'true') {
                    window.AuthUI.showMessage('Login restricted. You cannot login until you accept the cookies')
                    // window.WatchlistApp.Popup.showNotificationPopup('Login Restricted', 'You can not log in until accept the cookies');
                    const consentElement = document.querySelector('.cookie-consent-container');
                    if (consentElement) consentElement.classList.remove('minimized');
                } else {
                    window.AuthUI.showAccountModal()
                }
            });
        }


        // close auth modal
        const authModalBg = document.querySelector('#authorization-pop-up .bg');
        if (authModalBg) authModalBg.addEventListener('click', window.AuthUI.closeAuthModal);
        const authModalCloseButton = document.querySelector('#authorization-pop-up .close-button');
        if (authModalCloseButton) authModalCloseButton.addEventListener('click', window.AuthUI.closeAuthModal);
        // close account modal
        const accountModalBg = document.querySelector('#account-pop-up .bg');
        if (accountModalBg) accountModalBg.addEventListener('click', window.AuthUI.closeAccountModal);
        
        
        // switch between sign in and sign up
        const authPopUp = document.querySelector('#authorization-pop-up');
        const switchToSignupBtn = document.querySelector('#authorization-pop-up .tip .go-to');
        if (authPopUp && switchToSignupBtn) {
            switchToSignupBtn.addEventListener('click', () => {
                authPopUp.classList.toggle('register-state');
                
                const title = document.querySelector('#authorization-pop-up h2');
                const tipMain = document.querySelector('#authorization-pop-up .tip .main-text');
                const tipGo = document.querySelector('#authorization-pop-up .tip .go-to');

                if (!authPopUp.classList.contains('register-state')) {
                    if (title) title.textContent = 'Lets continue!';
                    if (tipMain) tipMain.textContent = 'Do not have an account yet?';
                    if (tipGo) tipGo.textContent = 'Register now';
                } else {
                    if (title) title.textContent = 'Welcome!';
                    if (tipMain) tipMain.textContent = 'Already have an account?';
                    if (tipGo) tipGo.textContent = 'Login now';
                }
            })
        }
        
        
        // delete account - open and close pop up
        const deleteAccountPopUpBtn = document.querySelector('#account-pop-up .delete-account');
        if (deleteAccountPopUpBtn) deleteAccountPopUpBtn.addEventListener('click', window.AuthUI.showDeleteAccountPopUp)
        const deleteAccountPopUpCloseButton = document.querySelector('#delete-account-pop-up .cancel-pop-up');
        if (deleteAccountPopUpCloseButton) deleteAccountPopUpCloseButton.addEventListener('click', window.AuthUI.closeDeleteAccountPopUp)
        const deleteAccountPopUpBg = document.querySelector('#delete-account-pop-up .bg');
        if (deleteAccountPopUpBg) deleteAccountPopUpBg.addEventListener('click', window.AuthUI.closeDeleteAccountPopUp)
        const deleteAccountPopUpConfirmButton = document.querySelector('#delete-account-pop-up .confirm-delete-account');
        if (deleteAccountPopUpConfirmButton) deleteAccountPopUpConfirmButton.addEventListener('click', window.AuthUI.closeDeleteAccountPopUp)

        
        // reset password popup - close 
        const resetPasswordPopUpBg = document.querySelector('#reset-password-pop-up .bg');
        if (resetPasswordPopUpBg) resetPasswordPopUpBg.addEventListener('click', window.AuthUI.closeResetRequestModal)

        // set new password popup - close 
        const setNewPasswordPopUpBg = document.querySelector('#account-set-new-password .bg');
        if (setNewPasswordPopUpBg) setNewPasswordPopUpBg.addEventListener('click', window.AuthUI.closeResetUpdateModal)
        
        
        // complete account pop-up close
        const closeCompleteAccountPopUp = document.querySelector('#complete-account-pop-up .close-button')
        if (closeCompleteAccountPopUp) closeCompleteAccountPopUp.addEventListener('click', window.AuthUI.closeUpgradeModal)
        const completeAccountPopUpBg = document.querySelector('#complete-account-pop-up .bg');
        if (completeAccountPopUpBg) completeAccountPopUpBg.addEventListener('click', window.AuthUI.closeUpgradeModal)
        
        // close profile popup after opening completeAccountPopUp
        const dropdownRegisterBtn = window.AuthUI.getElements().dropdownRegisterBtn
        if (dropdownRegisterBtn) dropdownRegisterBtn.addEventListener('click', window.AuthUI.closeAccountModal)
        
        
        // prevent block info message
        const accountInfoContainer = document.querySelector("#account-info-message-pop-up");
        if (accountInfoContainer) {
            accountInfoContainer.addEventListener('click', (e) => {
                accountInfoContainer.classList.remove('fade-out', 'show')
            })
        }

        // gtag events
        window.AuthUI.getElements().resetRequestForm?.addEventListener('submit', () => {
            if (window.gtag) window.gtag('event', 'Desktop_TopNav_Account_ResetPW');
        });

    }
    
    
    showAuthModal() {
        const mainAuthBtn = window.AuthUI.getElements().mainAuthBtn;
        // if user is already logged in, do not show the auth modal, instead show the account dropdown
        if (mainAuthBtn && mainAuthBtn.dataset.loggedIn === 'true') return;

        const authModel = document.getElementById('authorization-pop-up');
        if (authModel) authModel.classList.add('show');
    }
    closeAuthModal() {
        if (__LOG_INFO__) AppLog.info('')
        const authModel = document.getElementById('authorization-pop-up');
        if (authModel) authModel.classList.remove('show');
    }

    showAccountModal() {
        const accountModal = document.getElementById('account-pop-up');
        if (accountModal) accountModal.classList.add('show');
    }
    closeAccountModal() {
        const accountModal = document.getElementById('account-pop-up');
        if (accountModal) accountModal.classList.remove('show');
    }
    
    toggleConfirmPasswordField(show) {
        // no need to toggle the confirm password field
    }

    showUpgradeModal() {
        const completeAccountPopUp = document.getElementById('complete-account-pop-up');
        if (completeAccountPopUp) completeAccountPopUp.classList.add('show');
    }
    closeUpgradeModal() {
        const completeAccountPopUp = document.getElementById('complete-account-pop-up');
        if (completeAccountPopUp) completeAccountPopUp.classList.remove('show');
    }

    showResetRequestModal() {
        const resetPasswordPopUp = document.getElementById('reset-password-pop-up');
        if (resetPasswordPopUp) resetPasswordPopUp.classList.add('show');
    }
    closeResetRequestModal() {
        const resetPasswordPopUp = document.getElementById('reset-password-pop-up');
        if (resetPasswordPopUp) resetPasswordPopUp.classList.remove('show');
    }
    showResetUpdateModal() {
        const setNewPasswordPopUp = document.getElementById('account-set-new-password');
        if (setNewPasswordPopUp) setNewPasswordPopUp.classList.add('show');
    }
    closeResetUpdateModal() {
        const setNewPasswordPopUp = document.getElementById('account-set-new-password');
        if (setNewPasswordPopUp) setNewPasswordPopUp.classList.remove('show');
    }
    
    showDeleteAccountPopUp() {
        const deleteAccountModel = document.getElementById('delete-account-pop-up');
        if (deleteAccountModel) deleteAccountModel.classList.add('show');
    }
    closeDeleteAccountPopUp() {
        const deleteAccountModel = document.getElementById('delete-account-pop-up');
        if (deleteAccountModel) deleteAccountModel.classList.remove('show');
    }

    getElements() {
        return {
            mainAuthBtn: document.querySelector("#main-header .auth-button"), // +
            mainAccountBtn: document.querySelector("#main-header .account-button"), // +
            // authForm: document.getElementById('auth-submit'), // -
            signupBtn: document.querySelector('#authorization-pop-up .register'), // +
            signinBtn: document.querySelector('#authorization-pop-up .login'), // +
            // dropdownUpdateBtn: document.getElementById('dropdown-update-btn'),
            dropdownSignoutBtn: document.querySelector('#account-pop-up .pop-up .buttons-block .log-out'), // +
            dropdownDeleteBtn: document.querySelector('#delete-account-pop-up .confirm-delete-account'), // +
            // dropdownDisplayName: document.getElementById('dropdown-display-name'),
            // passcode: document.getElementById('passcode'),
            email: document.querySelector('#authorization-pop-up input[name="email"]'),  // +
            password: document.querySelector('#authorization-pop-up input[name="password"]'), // +
            confirmPassword: document.querySelector('#authorization-pop-up input[name="password-confirm"]'), // +
            // ? message: document.getElementById('message'),
            
            // profile update elements
            profileUpdateForm: document.querySelector('#account-pop-up .name-control-block'), // +
            profileUpdateFormInput: document.querySelector('#account-pop-up  .current-user-name-input'), // +
            profileUpdateFormButton: document.querySelector('#account-pop-up button.change-name'), // +
            
            // New upgrade modal elements
            upgradeForm: document.querySelector('#complete-account-pop-up .upgrade-form'), // +
            upgradeEmail: document.querySelector('#complete-account-pop-up input[name="email"]'), // +
            upgradePassword: document.querySelector('#complete-account-pop-up input[name="password"]'), // +
            upgradeConfirmPassword: document.querySelector('#complete-account-pop-up input[name="password-confirm"]'), // +
            completeAccountBtn: document.querySelector('#complete-account-pop-up button.complete-account'), // +
            googleUpgradeBtn: document.querySelector('#complete-account-pop-up button.google-complete'), // +


            dropdownRegisterBtn: document.querySelector('#account-pop-up button.complete-account'), // +
            
            googleSigninBtn: document.querySelector('#authorization-pop-up .google-login'), // +
            
            // Password reset elements
            forgotPasswordLink: document.querySelector('#authorization-pop-up .reset-password'), // +
            resetRequestForm: document.querySelector('#reset-password-pop-up .reset-password-form'), // +
            resetEmail: document.querySelector('#reset-password-pop-up input[name="email"]'), // +
            sendResetLinkBtn: document.querySelector('#reset-password-pop-up .send-reset-password'), // +
            resetRequestMessage: document.querySelector('#reset-password-pop-up .reset-request-message'), // +
            
            resetUpdateForm: document.querySelector('#account-set-new-password .reset-update-form'), // +
            newPassword: document.querySelector('#account-set-new-password input[name="password"]'), // +
            confirmNewPassword: document.querySelector('#account-set-new-password input[name="password-confirm"]'), // +
            resetUpdateMessage: document.querySelector('#account-set-new-password .reset-request-message'), // +
            resetPasswordSubmitBtn: document.querySelector('#account-set-new-password button.set-new-password'), // +
            
            // Strength meter and visibility toggle
            newPasswordStrengthBar: document.getElementById('new-password-strength-bar'),
            newPasswordStrengthText: document.getElementById('new-password-strength-text'),
            toggleNewPasswordVisibility: document.getElementById('toggle-new-password-visibility'),

            displayedNameText: document.querySelector('#account-pop-up .current-user-name-text'), // +
            displayedNameInput: document.querySelector('#account-pop-up .current-user-name-input'), // +
        };
    }

    showMessage(message, isError) {
        if (isError) {
            if (__LOG_ERROR__) AppLog.error(message);
        } else {
            if (__LOG_INFO__) AppLog.info(message);
        }
        // alert(message);
        
        const accountInfoText = document.querySelector("#account-info-message-pop-up h2");
        const accountInfoContainer = document.querySelector("#account-info-message-pop-up");
        if (accountInfoText && accountInfoContainer) {
            accountInfoText.textContent = message;
            accountInfoContainer.classList.add('show');
            setTimeout(() => accountInfoContainer.classList.add('fade-out'), 2000)
            setTimeout(() => accountInfoContainer.classList.remove('fade-out', 'show'), 3000)
        }
    }

}
// Create global instance
window.AuthUI = new AuthUI();

// Auto-initialize when DOM is loaded
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        window.AuthUI.init();
    });
} else {
    window.AuthUI.init();
}    